import { ExploreContext } from "context/ExploreContext";
import { useContext } from "react";
import Segmented from "components/BaseWidgets/Segmented";
import { GridIcon, ListIcon } from "assets/icons";
import FilterTags from "../FilterTags";
import { useProfileCompletion } from "hooks/api/useHome";

function ExploreHeader({
  title,
  description,
  segment = true,
  isContact,
  pending = 0,
  totalProfiles = 0,
  isEngage,
}) {
  const { cardLayout, setCardLayout } = useContext(ExploreContext);
  const { data: userData } = useProfileCompletion();

  return (
    <div className="flex flex-col gap-6">
      {segment && title && description && (
        <div className="flex items-start justify-between gap-3 flex-wrap">
          <div className="flex flex-col gap-1">
            {title && (
              <h1 className="font-title-lg fw-700 leading-3">{title}</h1>
            )}
            {description && <p className="font-body-md2">{description}</p>}
          </div>
          <Segmented
            state={cardLayout}
            setState={setCardLayout}
            options={[
              { value: "grid", icon: <GridIcon /> },
              { value: "list", icon: <ListIcon /> },
            ]}
          />
        </div>
      )}
      <FilterTags />
      <div className="flex items-center flex-wrap justify-between gap-3">
        <p className="font-body-normal leading-1">
          {isEngage ? (
            <>
              <span className="fw-700 mr-1">{totalProfiles}</span> profiles
              found
            </>
          ) : (
            <>Keep scrolling to discover more matches!</>
          )}
        </p>
        {isContact && (
          <p className="font-body-normal leading-1 fw-400">
            You have
            <span className="ml-1 mr-1 fw-700 text-primary">
              {userData?.common_home_data?.contact_limit} out of{" "}
              {userData?.common_home_data?.total_contact_count}
            </span>
            contact views left.
          </p>
        )}
      </div>
    </div>
  );
}

export default ExploreHeader;
